var _path, _rect, _rect2, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#E8BF55",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E8BF55",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.5L10.7847 20.3739L11 19.5ZM10 5L10.8731 4.78169L10.3796 2.80795L9.25116 4.5008L10 5ZM11.4999 11.5L10.6461 11.7846L11.2931 13.7254L12.2866 11.9371L11.4999 11.5ZM14 7L14.72 6.46L13.8873 5.34973L13.2133 6.5629L14 7ZM17 17.5L17.74 18.0123L17 17.5ZM11.2153 18.6261C9.44158 18.1891 8.54442 17.4339 8.0564 16.6153C7.54624 15.7596 7.39988 14.6995 7.39988 13.5H5.59988C5.59988 14.8005 5.74814 16.2586 6.51032 17.5371C7.29463 18.8526 8.64752 19.8473 10.7847 20.3739L11.2153 18.6261ZM7.39988 13.5C7.39988 11.9041 7.95904 10.2998 8.67874 8.87123C9.39766 7.44425 10.2321 6.27442 10.7489 5.4992L9.25116 4.5008C8.76801 5.22558 7.8524 6.51081 7.07122 8.06136C6.29083 9.61036 5.59988 11.506 5.59988 13.5H7.39988ZM9.12691 5.21831C9.37154 6.19667 9.61596 7.41944 9.86925 8.62287C10.1168 9.79899 10.3767 10.9767 10.6461 11.7846L12.3537 11.2154C12.123 10.5233 11.883 9.45101 11.6307 8.25213C11.3841 7.08056 11.1286 5.80333 10.8731 4.78169L9.12691 5.21831ZM12.2866 11.9371L14.7868 7.4371L13.2133 6.5629L10.7131 11.0629L12.2866 11.9371ZM13.28 7.54C13.7963 8.22838 15.5321 10.5765 16.195 11.9025L17.805 11.0975C17.0538 9.59502 15.2037 7.10495 14.72 6.46L13.28 7.54ZM16.195 11.9025C17.1246 13.7616 17.3263 15.4476 16.2601 16.9877L17.74 18.0123C19.3413 15.6993 18.8755 13.2384 17.805 11.0975L16.195 11.9025ZM16.2601 16.9877C15.1136 18.6437 13.338 19.1491 11.2153 18.6261L10.7847 20.3739C13.4583 21.0326 16.0747 20.4178 17.74 18.0123L16.2601 16.9877Z",
    fill: "#DEA30C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5H20V-1.5H4V1.5ZM22.5 4V20H25.5V4H22.5ZM20 22.5H4V25.5H20V22.5ZM1.5 20V4H-1.5V20H1.5ZM4 22.5C2.61929 22.5 1.5 21.3807 1.5 20H-1.5C-1.5 23.0376 0.962435 25.5 4 25.5V22.5ZM22.5 20C22.5 21.3807 21.3807 22.5 20 22.5V25.5C23.0376 25.5 25.5 23.0376 25.5 20H22.5ZM20 1.5C21.3807 1.5 22.5 2.61929 22.5 4H25.5C25.5 0.962434 23.0376 -1.5 20 -1.5V1.5ZM4 -1.5C0.962434 -1.5 -1.5 0.962435 -1.5 4H1.5C1.5 2.61929 2.61929 1.5 4 1.5V-1.5Z",
    fill: "#DEA30C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasIcon);
export default __webpack_public_path__ + "static/media/gasIcon.45ad67247b8d8857d71ace292adbcba2.svg";
export { ForwardRef as ReactComponent };